<div class="flex-layout jewelry-claims-permissions" (click)="hidePopover($event)">
  <form [formGroup]="personalLinesForm">
    <div>
      <h2>
        Personal Insurance Permissions
      </h2>
    </div>
    <div class="row">
      <div class="col-md-3">
        View Customer Jewelry Claims details
        <img src="/assets/images/JMicons/info_outline.png" id="view-pl-info" width="20" [placement]="['bottom-left', 'bottom-right', 'right']" [ngbPopover]="personalLinesPopup" #popover="ngbPopover">
      </div>
      <div class="col-md-3 pl-md-2">
        <mat-checkbox formControlName="allowed" (change)="setFormToDirty()">Allowed</mat-checkbox>
      </div>
    </div>
    <div class="row footer">
      <mat-card-actions align="end" class="col save-container">
        <button mat-raised-button color="primary" type="button" [disabled]="personalLinesForm.invalid || !formIsDirty" (click)="onSubmit()">Save</button>
      </mat-card-actions>
    </div>
  </form>
</div>
<hr class="divider"/>


<ng-template #personalLinesPopup>
  <div class="row info-wrap popup-wrap" id="personalLinesPopup">
    <div class="col-10 info-head heading-12-onyx mb-1">
      Allowed must be selected for user to see Personal Insurance information.
    </div>
    <mat-icon class="col-2 close-wrap mb-1 text-right" width="12">close</mat-icon>
  </div>
</ng-template>

<app-in-progress [loading]="isLoading"></app-in-progress>